// typecheck: ignore file
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Container from 'components/Container.jsx';
import Dialog from 'components/Dialog.jsx';
import Field from 'components/Field.jsx';
import Label from 'components/Label.jsx';
import Radio from 'components/Radio.jsx';
import React from 'react';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Textarea from 'components/Textarea.jsx';

export const DEFAULT_OPTIONS = [
  'Inappropriate content',
  'Harassment/bullying',
  'Threatening harm to me or others',
  'Pretending to be someone else',
  'At risk of harming him or herself',
  'Using hate speech or encouraging extreme acts',
];
const OTHER = 'other';

class ReportToRemindSelectModal extends React.Component {
  static propTypes = {
    reportee: React.PropTypes.string.isRequired,
    title: React.PropTypes.string,
    options: React.PropTypes.arrayOf(React.PropTypes.string),
    notesPlaceholder: React.PropTypes.string,
    notesRequired: React.PropTypes.bool,
    buttonText: React.PropTypes.string,
    onCancel: React.PropTypes.func,
    onReport: React.PropTypes.func.isRequired,
    onRequestHide: React.PropTypes.func,
  };

  static defaultProps = {
    title: 'Report to Remind',
    options: DEFAULT_OPTIONS,
    notesPlaceholder: 'Why are you reporting this person?',
    notesRequired: false,
    buttonText: 'Report',
  };

  state = {
    selected: 0,
    notes: '',
  };

  cancelConfirmDialog = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.props.onRequestHide();
  };

  missingNotes = () => {
    return (this.props.notesRequired || this.state.selected === OTHER) && this.state.notes === '';
  };

  reportClicked = () => {
    this.props.onRequestHide();

    const reason =
      (this.state.selected === OTHER) ? 'Other' : this.props.options[this.state.selected];

    return this.props.onReport(reason, this.state.notes);
  };

  renderConfirmDialog = () => {
    return (
      <ConfirmDialog
        eventScreenName="ReportToRemindSelectModal"
        title={`Are you sure you want to report ${this.props.reportee} to Remind?`}
        subtext="We review all reports and handle them based on our guidelines.
          Thank you for helping to keep our community safe."
        actionButtonText="Report"
        cancelButtonText="Cancel"
        onConfirm={this.reportClicked}
      />
    );
  };

  renderOption = (option, index) => {
    return (
      <Radio
        name="report-message"
        checked={this.state.selected === index}
        onChange={() => this.setState({ selected: index })}
        key={index}>
        {option}
      </Radio>
    );
  };

  handleTextChange = (event: SyntheticEvent) => {
    this.setState({ notes: event.target.value });
  };

  render() {
    const subtext = `Why are you reporting ${this.props.reportee}?`;
    const confirmDialog = this.renderConfirmDialog();
    let notesPlaceholder = this.props.notesPlaceholder;

    if (this.props.notesRequired) {
      notesPlaceholder = `${this.props.notesPlaceholder} (Required)`;
    } else if (subtext === this.props.notesPlaceholder) {
      notesPlaceholder = '';
    }

    return (
      <Dialog
        {...this.props}
        size="small"
        className="ReportToRemindSelectModal"
        title={this.props.title}
        subtext={subtext}>
        <BoxBody divided>
          {this.props.children}
          <form>
            <Field>
              <Label text="Reason" />
              {this.props.options.map(this.renderOption)}
              <Radio
                name="report-message"
                checked={this.state.selected === OTHER}
                onChange={() => this.setState({ selected: OTHER })}>
                Other
              </Radio>
            </Field>
            <Field>
              <Label text="Notes" />
              <Textarea
                name="notes"
                value={this.state.notes}
                placeholder={notesPlaceholder}
                required={this.props.notesRequired}
                rows={2}
                onChange={this.handleTextChange}
              />
            </Field>
          </form>
          <Container size="xxsmall">
            <Buttons full>
              <Button level="secondary" onClick={this.cancelConfirmDialog}>Cancel</Button>
              <ModalTrigger modal={confirmDialog}>
                <Button disabled={this.missingNotes()}>
                  {this.props.buttonText}
                </Button>
              </ModalTrigger>
            </Buttons>
          </Container>
        </BoxBody>
      </Dialog>
    );
  }
}

export default ReportToRemindSelectModal;



// WEBPACK FOOTER //
// ./src/support/components/ReportToRemindSelectModal.jsx